import React from "react"
import S from "./StyledMainOfferSection"
import BuildingImg from "../../images/nda/icons/project-management.png"
import Supervisor from "../../images/nda/icons/supervisor-icon.svg"
import BuildingSearch from "../../images/nda/icons/search.svg"
import HighwayImg from "../../images/nda/icons/highway.png"
import { Link } from "gatsby"

class MainOfferSection extends React.Component {
  constructor(props) {
    super(props)
    this.statsRef = React.createRef()
  }

  render() {
    return (
      <S.OfferWrapper id="oferta" ref={this.statsRef}>
        <S.OfferTitle>Oferta</S.OfferTitle>
        <S.OfferDescription>
          Zapraszamy do zapoznania się z ofertą <Link to="/firma-nda">firmy NDA</Link>, która powstała z
          myślą o klientach indywidualnych oraz przedsiębiorstwach. Naszym
          głównym celem jest świadczenie usług w zakresie kierowania budową oraz
          nadzoru inwestorskiego w specjalności konstrukcyjno-budowlanej
          (budownictwo mieszkaniowe jedno i wielorodzinne oraz przemysłowe),
          inżynieryjnej drogowej oraz kolejowej w zakresie kolejowych obiektów
          budowlanych.
        </S.OfferDescription>

        <S.OfferDescription>
          Jako{" "}
          <Link to="/kierownik-budowy-zachodniopomorskie/">
            kierownik budowy
          </Link>
          , zapewniamy kompleksowe zarządzanie procesem budowlanym, począwszy od
          planowania, przez realizację, aż do odbioru końcowego. Dzięki temu,
          nasi klienci mogą mieć pewność, że inwestycja będzie wykonana zgodnie
          z wymaganiami, w ustalonym czasie oraz z zachowaniem najwyższych
          standardów jakościowych.
        </S.OfferDescription>
        <S.OfferDescription className="lighten">
          Nasza siedziba znajduje się w miejscowości Recz, woj.
          zachodniopomorskie. Obszar naszej działalności obejmuje województwa
          zachodniopomorskie oraz lubuskie, w tym miasta takie jak Szczecin,
          Stargard, Choszczno, Barlinek, Gorzów Wielkopolski, Drawsko Pomorskie.
        </S.OfferDescription>
        <S.OfferIconsWrapper>
          <ul>
            <li>
              <S.IconWrapper src={BuildingImg} />
              <span>Kierowanie budową</span>
            </li>
            <li>
              <Supervisor />
              <span>Nadzór inwestorski</span>
            </li>
            <li>
              <BuildingSearch />
              <span>Przegląd okresowy budynków</span>
            </li>
            <li>
              <S.IconWrapper src={HighwayImg} />
              <span>Kierownik robót drogowych / kolejowych / torowych</span>
            </li>
          </ul>
        </S.OfferIconsWrapper>
      </S.OfferWrapper>
    )
  }
}

export default MainOfferSection
